import { Injectable } from '@angular/core';
import { CoreRepository } from '@tcc-mono/shared/data-access';
import { VionAnimalService } from '@tcc-mono/vandijk/shared/data-access/vandijk-api';
import { VionAnimal } from '@tcc-mono/vandijk/shared/data-access/models';

@Injectable({
  providedIn: 'root'
})
export class VionAnimalRepository extends CoreRepository<VionAnimal> {

  public constructor(
    protected readonly _vionAnimalService: VionAnimalService
  ) {
    super(
      { name: 'vionAnimals' },
      _vionAnimalService
    )
  }
}
